// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  background: #6c2fbb;
  border-radius: 8px;
  outline: none;
  border: none;
  max-width: 120px;
  width: 100%;
  height: 40px;
  color: #ffffff;
}

.cdk-overlay-pane.my-dialog {
  position: relative !important;
}
.close.mat-button {
  top: 0;
  right: 0;
  padding: 5px;
  line-height: 14px;
  min-width: auto;
}

/* Tree Styling */
.tree-conntainer {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.genealogy-scroll::-webkit-scrollbar {
  width: 5px;
  height: 20px;
}

.genealogy-scroll::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #e4e4e4;
}

.genealogy-scroll::-webkit-scrollbar-thumb {
  background: #212121;
  border-radius: 10px;
  -webkit-transition: 0.5s;
  transition: 0.5s;
}

.genealogy-scroll::-webkit-scrollbar-thumb:hover {
  background: #d5b14c;
  -webkit-transition: 0.5s;
  transition: 0.5s;
}

.grabbable {
  cursor: move;
  cursor: grab;
  cursor: -webkit-grab;
}

.grabbable:active {
  cursor: grabbing;
  cursor: -webkit-grabbing;
}

.genealogy-body {
  white-space: nowrap;
  overflow-x: auto;
  /* padding: 50px; */
  padding-top: 10px;
  /*padding-bottom: 80px;*/
  text-align: center;
}

.genealogy-tree {
  margin-top: 1rem;
  display: inline-block;
  position: relative;
  z-index: 1;
}

.form-control.edit-comment {
  box-shadow: none;
}

.genealogy-tree ul {
  padding-top: 20px;
  position: relative;
  padding-left: 0px;
  display: flex;
  justify-content: center;
}

.genealogy-tree li {
  float: left;
  text-align: center;
  list-style-type: none;
  position: relative;
  padding: 20px 10px 0 10px;
}

.genealogy-tree li::before,
.genealogy-tree li::after {
  content: "";
  position: absolute;
  top: 0;
  right: 50%;
  border-top: 3px solid #d5b14c;
  width: 50%;
  height: 18px;
}

.genealogy-tree li::after {
  right: auto;
  left: 50%;
  border-left: 3px solid #d5b14c;
}

.genealogy-tree li:only-child::after,
.genealogy-tree li:only-child::before {
  display: none;
}

.genealogy-tree li:only-child {
  padding-top: 0;
}

.genealogy-tree li:first-child::before,
.genealogy-tree li:last-child::after {
  border: 0 none;
}

.genealogy-tree li:last-child::before {
  border-right: 3px solid #d5b14c;
  border-radius: 0 5px 0 0;
  -webkit-border-radius: 0 5px 0 0;
  -moz-border-radius: 0 5px 0 0;
}

.genealogy-tree li:first-child::after {
  border-radius: 5px 0 0 0;
  -webkit-border-radius: 5px 0 0 0;
  -moz-border-radius: 5px 0 0 0;
}

.genealogy-tree ul ul::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 3px solid #d5b14c;
  width: 0;
  height: 20px;
}

.genealogy-tree li a {
  text-decoration: none;
  color: #666;
  font-family: arial, verdana, tahoma;
  font-size: 11px;
  display: inline-block;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
}

/* Single Video */

.member-view-box {
  text-align: center;
  border-radius: 2px;
  position: relative;
}

.member-image {
  /* width: 100px; */
  position: relative;
  z-index: 10;
  width: 150px;
}

.member-image:hover {
  transform: scale(1.05);
  transition: 0.3s;
}

.member-image img {
  height: 73px;
  border-radius: 6px;
  background-color: #000;
  z-index: 1;
  border: 2px solid black;
  width: 100%;
  border-radius: 4px 4px 0px 0px;
  object-fit: fill;
}

.img-fluid {
  max-width: none !important;
}

.viwedVideo {
  border: 3px solid green;
}

.child-name {
  background: #e6e6e6;
  color: black;
  font-size: 12px;
  margin: 0 auto;
  border-radius: 0px 0px 4px 4px;
  border: 1px solid #9a9a9a;
  padding: 0 2px;
  white-space: initial;
  word-break: break-word;
  line-height: 1.5;
}

.selected-video {
  background: #4cec5a;
  color: white;
}

.comment-count {
  position: absolute;
  top: 0px;
  font-size: 18px;
  color: #d2ba45;
  width: 28px;
  height: 28px;
  right: 0px;
  border: 1px solid #d2ba45;
  background-color: white;
}

.fa-infos {
  font-size: 22px;
  position: absolute;
  left: 0px;
  top: 0px;
  background: white;
  padding: 14px;
  height: 28px;
  width: 28px;
}

.fa-infos img {
  background: none !important;
  height: 28px !important;
  border: none !important;
  background: white !important;
  padding: 2px !important;
  width: 28px !important;
  position: absolute !important;
  left: 0;
  top: 0;
}

.question-view {
  font-size: 22px;
  position: absolute !important;
  left: 0px;
  top: -2px;
  color: #ba65cc;
  background: #ffffff;
  padding: 6px;
  /* border-radius: 50%; */
  width: 32px;
  height: 32px;
}

.lock-position {
  position: absolute;
  top: 30%;
  left: 0;
  right: 0;
  width: 100%;
}

.fa-check {
  color: green;
  font-size: 25px;
  z-index: 150;
  pointer-events: none;
}

.button-col {
  justify-content: flex-end;
}

.add-video {
  margin-right: 1rem;
}

.pro-img {
  width: 50px;
  height: 50px;
  border-radius: 10px;
}

.profile-image {
  width: 50px;
  height: 50px;
  font-size: 22px;
  line-height: 30px;
  border-radius: 10px;
}

.collab-checkbox {
  display: flex !important;
  line-height: 0px;
}

::ng-deep.open-collab-dialog .mat-dialog-container {
  overflow: overlay;
}

.collab-list-username {
  margin: 25px 8px;
}

/* Tab Bar */
.tab-box-video {
  width: 100%;
  margin-top: 20px;
}

.tab-box-video ul {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.tab-box-video ul li {
  list-style: none;
  font-weight: 500;
  font-size: 18px;
  padding: 5px 0;
  margin: 0px 25px;
  color: #878395;
  cursor: pointer;
}

.tab-box-video ul li.active {
  border-top: 3px solid rgba(108, 47, 187, 1);
  color: rgba(108, 47, 187, 1);
}

.zoom-btn-group {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.zoom-btn {
  height: -moz-fit-content;
  height: fit-content;
  box-shadow: 1px 1px 4px 0 rgb(0 0 0 / 20%);
  font-size: 14px;
  margin: 5px;
  border: none;
  padding: 5px 13px;
  background: #6c2fbb;
  color: #fff;
  border-radius: 5px;
  margin-bottom: 3px;
}

.c-cmt {
  color: #6c2fbb;
  cursor: pointer;
}

@media (max-width: 767px){
  .zoom-btn-group {
    padding-left: 10px;
    margin-top: 7px;
    justify-content: flex-start;
  }
  ::ng-deep mat-dialog-content.main-section {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
  ::ng-deep mat-dialog-content.main-section .member-image {
    width: 230px;
  }
  ::ng-deep mat-dialog-content.main-section .genealogy-tree li {
    padding: 0 !important;
  }
  ::ng-deep mat-dialog-content.main-section .genealogy-tree ul {
    gap: 15px;
  }
  ::ng-deep mat-dialog-content.main-section .genealogy-tree {
    height: 370px;
  }
  ::ng-deep .fullscreen-dialog mat-dialog-content.main-section .genealogy-tree {
    height: 60vh;
  }
  ::ng-deep mat-dialog-content.main-section .zoom-btn-group {
    flex-wrap: wrap;
    justify-content: center;
  }
  ::ng-deep mat-dialog-content.main-section .zoom-btn-group .zoom-btn {
    margin: 3px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/layout/modals/open-collab/open-collab.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wBAAgB;EAAhB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAgB;EAAhB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EAEZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAEhB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,6BAA6B;EAC7B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAS;EACT,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,8BAA8B;EAC9B,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,iBAAiB;;AAEjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,OAAO;EACP,MAAM;AACR;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,SAAS;EACT,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,2BAA2B;EAC7B;EACA;IACE,SAAS;IACT,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,qBAAqB;EACvB;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".button {\n  background: #6c2fbb;\n  border-radius: 8px;\n  outline: none;\n  border: none;\n  max-width: 120px;\n  width: 100%;\n  height: 40px;\n  color: #ffffff;\n}\n\n.cdk-overlay-pane.my-dialog {\n  position: relative !important;\n}\n.close.mat-button {\n  top: 0;\n  right: 0;\n  padding: 5px;\n  line-height: 14px;\n  min-width: auto;\n}\n\n/* Tree Styling */\n.tree-conntainer {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.genealogy-scroll::-webkit-scrollbar {\n  width: 5px;\n  height: 20px;\n}\n\n.genealogy-scroll::-webkit-scrollbar-track {\n  border-radius: 10px;\n  background-color: #e4e4e4;\n}\n\n.genealogy-scroll::-webkit-scrollbar-thumb {\n  background: #212121;\n  border-radius: 10px;\n  transition: 0.5s;\n}\n\n.genealogy-scroll::-webkit-scrollbar-thumb:hover {\n  background: #d5b14c;\n  transition: 0.5s;\n}\n\n.grabbable {\n  cursor: move;\n  cursor: grab;\n  cursor: -moz-grab;\n  cursor: -webkit-grab;\n}\n\n.grabbable:active {\n  cursor: grabbing;\n  cursor: -moz-grabbing;\n  cursor: -webkit-grabbing;\n}\n\n.genealogy-body {\n  white-space: nowrap;\n  overflow-x: auto;\n  /* padding: 50px; */\n  padding-top: 10px;\n  /*padding-bottom: 80px;*/\n  text-align: center;\n}\n\n.genealogy-tree {\n  margin-top: 1rem;\n  display: inline-block;\n  position: relative;\n  z-index: 1;\n}\n\n.form-control.edit-comment {\n  box-shadow: none;\n}\n\n.genealogy-tree ul {\n  padding-top: 20px;\n  position: relative;\n  padding-left: 0px;\n  display: flex;\n  justify-content: center;\n}\n\n.genealogy-tree li {\n  float: left;\n  text-align: center;\n  list-style-type: none;\n  position: relative;\n  padding: 20px 10px 0 10px;\n}\n\n.genealogy-tree li::before,\n.genealogy-tree li::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 50%;\n  border-top: 3px solid #d5b14c;\n  width: 50%;\n  height: 18px;\n}\n\n.genealogy-tree li::after {\n  right: auto;\n  left: 50%;\n  border-left: 3px solid #d5b14c;\n}\n\n.genealogy-tree li:only-child::after,\n.genealogy-tree li:only-child::before {\n  display: none;\n}\n\n.genealogy-tree li:only-child {\n  padding-top: 0;\n}\n\n.genealogy-tree li:first-child::before,\n.genealogy-tree li:last-child::after {\n  border: 0 none;\n}\n\n.genealogy-tree li:last-child::before {\n  border-right: 3px solid #d5b14c;\n  border-radius: 0 5px 0 0;\n  -webkit-border-radius: 0 5px 0 0;\n  -moz-border-radius: 0 5px 0 0;\n}\n\n.genealogy-tree li:first-child::after {\n  border-radius: 5px 0 0 0;\n  -webkit-border-radius: 5px 0 0 0;\n  -moz-border-radius: 5px 0 0 0;\n}\n\n.genealogy-tree ul ul::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 50%;\n  border-left: 3px solid #d5b14c;\n  width: 0;\n  height: 20px;\n}\n\n.genealogy-tree li a {\n  text-decoration: none;\n  color: #666;\n  font-family: arial, verdana, tahoma;\n  font-size: 11px;\n  display: inline-block;\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n}\n\n/* Single Video */\n\n.member-view-box {\n  text-align: center;\n  border-radius: 2px;\n  position: relative;\n}\n\n.member-image {\n  /* width: 100px; */\n  position: relative;\n  z-index: 10;\n  width: 150px;\n}\n\n.member-image:hover {\n  transform: scale(1.05);\n  transition: 0.3s;\n}\n\n.member-image img {\n  height: 73px;\n  border-radius: 6px;\n  background-color: #000;\n  z-index: 1;\n  border: 2px solid black;\n  width: 100%;\n  border-radius: 4px 4px 0px 0px;\n  object-fit: fill;\n}\n\n.img-fluid {\n  max-width: none !important;\n}\n\n.viwedVideo {\n  border: 3px solid green;\n}\n\n.child-name {\n  background: #e6e6e6;\n  color: black;\n  font-size: 12px;\n  margin: 0 auto;\n  border-radius: 0px 0px 4px 4px;\n  border: 1px solid #9a9a9a;\n  padding: 0 2px;\n  white-space: initial;\n  word-break: break-word;\n  line-height: 1.5;\n}\n\n.selected-video {\n  background: #4cec5a;\n  color: white;\n}\n\n.comment-count {\n  position: absolute;\n  top: 0px;\n  font-size: 18px;\n  color: #d2ba45;\n  width: 28px;\n  height: 28px;\n  right: 0px;\n  border: 1px solid #d2ba45;\n  background-color: white;\n}\n\n.fa-infos {\n  font-size: 22px;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  background: white;\n  padding: 14px;\n  height: 28px;\n  width: 28px;\n}\n\n.fa-infos img {\n  background: none !important;\n  height: 28px !important;\n  border: none !important;\n  background: white !important;\n  padding: 2px !important;\n  width: 28px !important;\n  position: absolute !important;\n  left: 0;\n  top: 0;\n}\n\n.question-view {\n  font-size: 22px;\n  position: absolute !important;\n  left: 0px;\n  top: -2px;\n  color: #ba65cc;\n  background: #ffffff;\n  padding: 6px;\n  /* border-radius: 50%; */\n  width: 32px;\n  height: 32px;\n}\n\n.lock-position {\n  position: absolute;\n  top: 30%;\n  left: 0;\n  right: 0;\n  width: 100%;\n}\n\n.fa-check {\n  color: green;\n  font-size: 25px;\n  z-index: 150;\n  pointer-events: none;\n}\n\n.button-col {\n  justify-content: flex-end;\n}\n\n.add-video {\n  margin-right: 1rem;\n}\n\n.pro-img {\n  width: 50px;\n  height: 50px;\n  border-radius: 10px;\n}\n\n.profile-image {\n  width: 50px;\n  height: 50px;\n  font-size: 22px;\n  line-height: 30px;\n  border-radius: 10px;\n}\n\n.collab-checkbox {\n  display: flex !important;\n  line-height: 0px;\n}\n\n::ng-deep.open-collab-dialog .mat-dialog-container {\n  overflow: overlay;\n}\n\n.collab-list-username {\n  margin: 25px 8px;\n}\n\n/* Tab Bar */\n.tab-box-video {\n  width: 100%;\n  margin-top: 20px;\n}\n\n.tab-box-video ul {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n.tab-box-video ul li {\n  list-style: none;\n  font-weight: 500;\n  font-size: 18px;\n  padding: 5px 0;\n  margin: 0px 25px;\n  color: #878395;\n  cursor: pointer;\n}\n\n.tab-box-video ul li.active {\n  border-top: 3px solid rgba(108, 47, 187, 1);\n  color: rgba(108, 47, 187, 1);\n}\n\n.zoom-btn-group {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.zoom-btn {\n  height: fit-content;\n  box-shadow: 1px 1px 4px 0 rgb(0 0 0 / 20%);\n  font-size: 14px;\n  margin: 5px;\n  border: none;\n  padding: 5px 13px;\n  background: #6c2fbb;\n  color: #fff;\n  border-radius: 5px;\n  margin-bottom: 3px;\n}\n\n.c-cmt {\n  color: #6c2fbb;\n  cursor: pointer;\n}\n\n@media (max-width: 767px){\n  .zoom-btn-group {\n    padding-left: 10px;\n    margin-top: 7px;\n    justify-content: flex-start;\n  }\n  ::ng-deep mat-dialog-content.main-section {\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n  }\n  ::ng-deep mat-dialog-content.main-section .member-image {\n    width: 230px;\n  }\n  ::ng-deep mat-dialog-content.main-section .genealogy-tree li {\n    padding: 0 !important;\n  }\n  ::ng-deep mat-dialog-content.main-section .genealogy-tree ul {\n    gap: 15px;\n  }\n  ::ng-deep mat-dialog-content.main-section .genealogy-tree {\n    height: 370px;\n  }\n  ::ng-deep .fullscreen-dialog mat-dialog-content.main-section .genealogy-tree {\n    height: 60vh;\n  }\n  ::ng-deep mat-dialog-content.main-section .zoom-btn-group {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n  ::ng-deep mat-dialog-content.main-section .zoom-btn-group .zoom-btn {\n    margin: 3px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
